import { DSButton } from "components/UI/atoms";
import "./index.scss";

export const BrandAlertCancelConfirm = ({
  handleKeepAlert,
  handleCancelAlert
}) => {
  return (
    <div
      className="brand-alert-cancel-confirm"
      data-testid="brand-alert-cancel-confirm"
    >
      <p>Are you sure you want to delete this alert?</p>
      <div className="buttons-area">
        <DSButton variant="outlined" onClick={handleKeepAlert}>
          Keep Alert
        </DSButton>
        <DSButton variant="secondary" onClick={handleCancelAlert}>
          Cancel Alert
        </DSButton>
      </div>
    </div>
  );
};
